<template>
    <div class="container-xxl flex-grow-1 container-p-y">
        <div class="card mb-4">
            <div class="card-body">
                <div class="row">
                    <InvoiceListTableComponent :invoices="invoices" />
                </div>
            </div>
        
    </div>
    </div>
    
</template>

<script>
    import axios from 'axios';
    import InvoiceListTableComponent from '../components/InvoiceListTable.vue';
    export default {
        components: { InvoiceListTableComponent },
        data() {
            return {
                invoices: [],
                loading: true,
                error: null,
                pollingInterval: null
            };
        },
        created() {
            this.fetchInvoiceData();
        },
        mounted() {
            // Start polling every 10 seconds
            this.pollingInterval = setInterval(() => {
                this.fetchInvoiceData();
            }, 10000);
        },
        beforeUnmount() {
            // Clear polling when component is destroyed
            clearInterval(this.pollingInterval);
        },
        methods: {
            fetchInvoiceData() {
                const customerId = localStorage.getItem('customerId');
                if(customerId != undefined){
                    axios.get('/api/zoho/customer-invoices/' + customerId)
                    .then(response => {
                        let data = response.data;
                        this.invoices = data.invoices;
                    })
                    .catch(() => {
                        this.error = 'Failed to fetch invoices.';
                    })
                    .finally(() => {
                        this.loading = false;
                    });
                }
            }

        },
    };
</script>

<style scoped>
/* Add dashboard styles here */
</style>
